import { CREDIT_CARD } from '@constants/paymentMethods'
import { useStyles } from '@hooks/useStyles'
import { PAYMENT_VIEWS } from '@pages/Checkout/constants'
import { useGetPaymentMethods } from '@pages/Checkout/hooks/useGetPaymentMethods'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Button, Heading, Loader, Panel, Radio, Spacer } from '@ui-kit'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'

import { Details } from './components/Details'
import styles from './PaymentMethod.module.scss'

const { DETAILS, FORM } = PAYMENT_VIEWS

export const PaymentMethod = () => {
  const { t } = useTranslation()

  const {
    formik,
    paymentMethodsData,
    paymentMethodsIsLoading,
    paymentMethodView,
    setPaymentMethodView,
    isCreditCardDataAvailable
  } = useCheckoutContext()

  const { values, handleChange, setFieldValue } = formik

  const { paymentMethod: selectedPaymentMethod } = values

  const paymentMethods = useGetPaymentMethods()

  const stylesDiv = useStyles({
    [styles['payment-method']]: true,
    [styles['payment-method--is-selected']]: true
  })

  useEffect(() => {
    const selected = paymentMethods.find(
      method => method.id === selectedPaymentMethod
    )

    if (selected && !selected.isVisible) {
      setFieldValue('paymentMethod', CREDIT_CARD)
    }
  }, [paymentMethods, selectedPaymentMethod, setFieldValue])

  const views = {
    [DETAILS]: <Details paymentMethodsData={paymentMethodsData} />,
    [FORM]: paymentMethods.map(({ id, label, description, isVisible }) => {
      const isSelected = id === selectedPaymentMethod

      return isVisible ? (
        <div
          key={id}
          className={isSelected ? stylesDiv : styles['payment-method']}
        >
          <div>
            <Radio
              id={id}
              label={label}
              field={{
                name: 'paymentMethod',
                value: selectedPaymentMethod,
                onChange: handleChange
              }}
            />
          </div>

          {isSelected ? (
            <div className={styles['payment-method__description']}>
              {description}
            </div>
          ) : null}
        </div>
      ) : null
    })
  }

  const buttons = {
    [DETAILS]: {
      label: 'word.edit',
      toView: FORM
    },
    [FORM]: {
      label: 'word.cancel',
      toView: DETAILS
    }
  }

  return (
    <Panel border='neutral-2' surface={0} padding={{ x: 20, y: 10 }}>
      <Row vertical='center' horizontal='space-between'>
        <div className={styles.heading}>
          <Heading level={3} weight={600}>
            {t('registration.flow.credit.card.step.your.payment.method')}
          </Heading>
        </div>

        {isCreditCardDataAvailable && paymentMethodView ? (
          <Button
            variant='text-primary'
            size={12}
            onClick={() => {
              setPaymentMethodView(buttons[paymentMethodView].toView)
            }}
          >
            {t(buttons[paymentMethodView].label)}
          </Button>
        ) : null}
      </Row>

      <Spacer space={20} />

      {paymentMethodsIsLoading || paymentMethodView === null ? (
        <Loader />
      ) : (
        views[paymentMethodView]
      )}
    </Panel>
  )
}

PaymentMethod.displayName = 'CheckoutPaymentPaymentMethod'
